/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createFieldHook } from '../../core/factories/createFieldHook.js';
import { createListHook } from '../../core/factories/createListHook.js';
import { createPrefetchHook } from '../../core/factories/createPrefetchHook.js';
import type { GetThesesRow } from '../openapi-types.gen.js';
import type { PagedData } from '../../types/PagedData.js';
import { type useGetThesesArgs, useGetThesesSpec, useGetThesesRealtime, useGetThesesPagination } from '../specs/theses.spec.gen.js';
import type { PaginationContract } from '../../core/factories/createListHook.js';

export type { GetThesesRow } from '../openapi-types.gen.js';
export type { useGetThesesArgs } from '../specs/theses.spec.gen.js';

// Codegen-typed pagination contract is narrower than the runtime
// PaginationContract signature (which takes unknown args). The cast erases
// the call-site narrowness — the runtime fetcher itself remains typed.
const _useGetThesesPaginationContract = useGetThesesPagination as unknown as PaginationContract;

/**
 * Manual pagination: returns `fetchNextPage` / `hasNextPage` /
 * `isFetchingNextPage` so the caller wires a "Load more" button or
 * pagination control. Same cache entry as `useGetThesesInfinite` — both
 * read/write the same `PagedData<GetThesesRow>` blob.
 *
 * @remarks Available query params (forwarded automatically; pass
 * via the hook's args): marketPubkey, authorId, walletPubkeys, category, sort, marketStatus, dedupePerMarket, topPerOutcome, limit, cursor.
 */
const _useGetTheses = createListHook({
  spec: useGetThesesSpec,
  realtime: useGetThesesRealtime,
  entityKey: null,
  pagination: _useGetThesesPaginationContract,
});
export const useGetTheses = _useGetTheses as (args: useGetThesesArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetTheses>;


/**
 * Auto-infinite: same cache as `useGetTheses`, but the last-row viewport
 * sentinel auto-fires `fetchNextPage` so the consumer never has to wire
 * it. Use for scroll-driven feeds; use `useGetTheses` for "Load more"
 * buttons / non-scroll UX.
 */
const _useGetThesesInfinite = createListHook({
  spec: useGetThesesSpec,
  realtime: useGetThesesRealtime,
  entityKey: null,
  pagination: _useGetThesesPaginationContract,
  autoLoadMore: true,
});
export const useGetThesesInfinite = _useGetThesesInfinite as (args: useGetThesesArgs, opts?: import('../../core/factories/createHook.js').CreateHookCallOpts) => ReturnType<typeof _useGetThesesInfinite>;


/**
 * Per-field subscription hook for the `useGetTheses` cache entry. Call inside
 * an `<Items>` render tree (typically from a leaf component). Returns the
 * named field's value for the given row id; only the call site re-renders
 * when that field changes. Uses TanStack's canonical "per-component select"
 * pattern internally.
 *
 *     function Volume({ pubkey }) {
 *       const value = useGetThesesField(pubkey, 'volume24h');
 *       return <span>{value}</span>;
 *     }
 */
export const useGetThesesField = createFieldHook<GetThesesRow>('useGetThesesField');

/**
 * Hover/intent prefetch companion for `useGetTheses` (also covers
 * `useGetThesesInfinite` — same cache entry). Returns a stable
 * `(args) => Promise<void>` callback that fires the real HTTP request
 * for page 1 and writes the response into the cache. The component owning
 * the callback does NOT subscribe — no re-renders on data, no NATS
 * subscription. Idempotent: TanStack `prefetchQuery` is a no-op when a
 * fresh cache entry already exists.
 *
 *     function NavLink() {
 *       const prefetch = usePrefetchGetTheses();
 *       return (
 *         <a
 *           onMouseEnter={() => prefetch({})}
 *           onFocus={() => prefetch({})}
 *         >Markets</a>
 *       );
 *     }
 */
export const usePrefetchGetTheses = createPrefetchHook(useGetThesesSpec) as () => import('../../types/SdkPrefetchTask.js').SdkPrefetcher<useGetThesesArgs>;
